import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import * as moment from 'moment';
import 'moment-duration-format';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss']
})
export class QuestionsComponent implements OnInit {

  public examTimerString: any = "";
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) {
    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0){
      var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
      generalSvc.logoutUser(enetsecure);
    }

    if (dataSvc.currentExamIndex == -1)
      generalSvc.loginUser();

    // find first un-answered question;
    var i = 0;
    var qfound = false;
    dataSvc.currentExam().Questions.forEach(question => {
      if (question.Disabled != true && !qfound){
        dataSvc.setQuestion(i);
        qfound = true;
      }
      i++;
    });

    if (!qfound)
      dataSvc.setQuestion(i-1);
  }

  ngOnInit() {
    this.initiateTimer();
  }

  initiateTimer(){
    var session = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session;
    var examTime = parseInt(session.AllotedTime) + parseInt(session.ExtraTime);
    var seconds = examTime * 60;
    var checkTime = seconds - this.dataSvc.currentExam().Session.TimeTakenInSeconds;
    if(checkTime <= 0){
      clearInterval(this.dataSvc.interval);
      this.dataSvc.EndExam();
    }
    else{
      this.startTimer(checkTime);
    }
  }

  startTimer(duration){
      this.dataSvc.currentExam().Session.timer = duration;

      //timer = 15;
      clearInterval(this.dataSvc.interval);
      this.dataSvc.interval = setInterval(() => {
        if (this.dataSvc.isConnected) {
          this.dataSvc.currentExam().Session.minutes = parseInt(this.dataSvc.currentExam().Session.timer) / 60;
          this.dataSvc.currentExam().Session.seconds = parseInt(this.dataSvc.currentExam().Session.timer) % 60;

          this.dataSvc.currentExam().Session.minutes = this.dataSvc.currentExam().Session.minutes < 10 ? "0" + this.dataSvc.currentExam().Session.minutes : this.dataSvc.currentExam().Session.minutes;
          this.dataSvc.currentExam().Session.seconds = this.dataSvc.currentExam().Session.seconds < 10 ? "0" + this.dataSvc.currentExam().Session.seconds : this.dataSvc.currentExam().Session.seconds;
          var pat = /\b(900)\b/g;
          if (--this.dataSvc.currentExam().Session.timer < 0) {
            this.dataSvc.currentExam().Session.timer = 0;
            //alert("Exam Finished");
            clearInterval(this.dataSvc.interval);
            this.dataSvc.EndExam();
          }
          else if(this.dataSvc.currentExam().Session.timer == 900 || this.dataSvc.currentExam().Session.timer.toString().match(pat)){
            document.getElementById("btnOpenTimer").click();
          }
          
          this.dataSvc.currentExam().Session.seconds = this.dataSvc.currentExam().Session.timer;
          this.dataSvc.currentExam().Session.duration = moment.duration(this.dataSvc.currentExam().Session.seconds, 'seconds');          
          this.examTimerString = this.dataSvc.currentExam().Session.duration.format("hh:mm:ss");

          // construct exam time taken;
          this.dataSvc.currentExam().Session.TimeTakenInSeconds++;

          // set time spent on question;
          if (this.dataSvc.currentQuestion().TimeSpent == null || this.dataSvc.currentQuestion().TimeSpent == undefined)
            this.dataSvc.currentQuestion().TimeSpent = 0;

          this.dataSvc.currentQuestion().TimeSpent ++;
        }
      }, 1000);
  }

  isExamTimeFinished(endTime, startTime, allottedTime){
    var now = moment().format();
    var end = moment(endTime).format();
    if(now >= end){
      clearInterval(this.dataSvc.interval);
      this.dataSvc.EndExam();
    }
    else{
      var start = moment(startTime).format();
      var difference = moment.duration(moment().diff(moment(start))).as('minutes');
      var minutes = difference;
      var allowedtime = (parseInt(allottedTime) * 60);
      var correctTime = allowedtime - (minutes * 60);
      return correctTime;
    }
  }
}